/** @jsx jsx */
import { jsx, Button, useThemeUI, Grid, Box } from "theme-ui";
import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorsOrWarnings from "./ErrorsOrWarnings";
import { RenderCard } from "./DonorProfile/ProfileSelector";

const ErrorsOrWarningsWrapper = ({
  show,
  openInfoEditor,
  ButtonPay,
  validateAndSubmitOW,
  country,
  donorInfo,
  resetDonorInfo,
  AfterSelection,
  errors,
  warnings,
  initialCurrency,
  toAmount,
  loading,
  validateAndSubmit,
  meditationPlaceFieldAvl,
}) => {
  const { theme } = useThemeUI();

  return (
    <React.Fragment>
      {show === "warnings-box" && (
        <div>
          <RenderCard
            country={country}
            me={donorInfo}
            iAmSelected
            selectMe={resetDonorInfo}
            editMe={false}
            deleteMe={false}
            meditationPlaceFieldAvl={meditationPlaceFieldAvl}
          />
          {errors.length > 0 && <AfterSelection />}
          {errors.length === 0 && warnings.length > 0 && (
            <div>
              <div sx={theme.messages.variantEW}>
                <Grid>
                  <Box
                    sx={{
                      marginLeft: "25px",
                    }}
                  >
                    <Grid gap={1} columns={["1fr 7fr"]}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="exclamation-circle"
                          sx={{ fontSize: "30px" }}
                        />
                      </Box>
                      <Box>
                        <h5 sx={{ marginTop: "5px" }}>
                          {" "}
                          <b> Please Note: </b>
                        </h5>
                      </Box>
                    </Grid>
                  </Box>
                </Grid>

                <ErrorsOrWarnings warnings={warnings} />
                {(warnings.includes("warning-in-pan") ||
                  warnings.includes("warning-in-identity")) && (
                  <div
                    sx={{
                      ...theme.messages.variantW,
                    }}
                  >
                    {warnings.includes("warning-in-pan") && (
                      <div
                        sx={{
                          ...theme.messages.variantW,
                        }}
                      >
                        <span>
                          If any one of the ID types is not given , the
                          organization needs to pay 30% tax on this donation.
                          The organisation would receive
                        </span>{" "}
                        <span>
                          <b>
                            {" "}
                            Only {initialCurrency} {Math.round(toAmount * 0.7)}{" "}
                          </b>{" "}
                          after tax.
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {(warnings.includes("warning-in-pan") ||
                warnings.includes("warning-in-identity")) && (
                <div>
                  <Button
                    sx={{ ...theme.buttons.variant3, fontSize: "0.8em" }}
                    onClick={openInfoEditor}
                  >
                    {" "}
                    Enter Pancard &amp; claim Income Tax Benefit{" "}
                  </Button>
                  <br />
                  <ButtonPay
                    sx={{ fontSize: "0.85em" }}
                    disabled={loading || errors.length > 0}
                    onClick={validateAndSubmitOW}
                    extraText={<span> without Pancard </span>}
                  />
                  <br />
                </div>
              )}
            </div>
          )}
          {errors.length === 0 && warnings.length === 0 && (
            <ButtonPay disabled={loading} onClick={validateAndSubmit} />
          )}
        </div>
      )}
    </React.Fragment>
  );
};
ErrorsOrWarningsWrapper.defaultProps = {
  meditationPlaceFieldAvl: false,
};

ErrorsOrWarningsWrapper.propTypes = {
  show: PropTypes.string.isRequired,
  openInfoEditor: PropTypes.func.isRequired,
  ButtonPay: PropTypes.element.isRequired,
  validateAndSubmitOW: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  donorInfo: PropTypes.shape({}).isRequired,
  resetDonorInfo: PropTypes.func.isRequired,
  AfterSelection: PropTypes.element.isRequired,
  errors: PropTypes.shape([]).isRequired,
  warnings: PropTypes.shape([]).isRequired,
  initialCurrency: PropTypes.string.isRequired,
  toAmount: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  validateAndSubmit: PropTypes.func.isRequired,
  meditationPlaceFieldAvl: PropTypes.bool,
};

export default ErrorsOrWarningsWrapper;
